import { useMemo } from 'react';
import { FilterConfigsDto } from '@asset-metrix/portal-gateway-client-js';
import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../store';

import {
  useCurrentStoreFilters,
  UseSyncFiltersToSearchParams,
  useSyncFiltersToSearchParams,
} from './useSyncFiltersToSearchParams';

type UseSyncPageFiltersToSearchParams = {
  config?: FilterConfigsDto;
  instanceId: string | null;
} & Pick<
  UseSyncFiltersToSearchParams,
  'navigationData' | 'navItemId' | 'pageData'
>;

export const useSyncPageFiltersToSearchParams = ({
  config,
  instanceId,
  navigationData,
  navItemId,
  pageData,
}: UseSyncPageFiltersToSearchParams) => {
  const filtersToSet = useCurrentStoreFilters([
    { config: config?.filters, instanceId },
  ]);

  const { filterLoaded, filterInitialised } = useStore(
    useShallow((state) => ({
      filterLoaded: instanceId
        ? state.filterData[instanceId]?.meta.loaded
        : false,
      filterInitialised: instanceId
        ? state.filterData[instanceId]?.meta.initialised
        : false,
    }))
  );

  const allFilterUrlKeys = useMemo(() => {
    // Don't sync filters if they are not loaded or initialised
    if (!filterLoaded || !filterInitialised) {
      return [];
    }
    return config?.filters.map((fc) => fc.key) ?? [];
  }, [filterLoaded, filterInitialised, config]);

  useSyncFiltersToSearchParams({
    filtersToSet,
    allFilterUrlKeys,
    navigationData,
    navItemId,
    pageData,
  });
};
